export { ExpressionCache } from "@cogo/runtime-v2"
export type { CachedExpression, CacheStats } from "@cogo/runtime-v2"
